export default {
  methods: {
    toCurrency({ value, signed = false }) {
      let pre = value < 0 ? '-' : '+';
      let ret = signed ? pre : '';
      ret += this.$n(value, 'currency');

      return ret;
    },

    toRangeCurrency({ min, max, signed = false }){
      return `${this.toCurrency({ value: min, signed })} - ${this.toCurrency({ value: max, signed })}`
    }
  }
}
